import React, { FC } from "react";
import { Spin, SpinProps } from "antd";
import styles from "./avelios-spinner.module.scss";
import { SpinningIcon } from "./spinning-icon";

export const AveliosSpinner: FC<SpinProps> = ({ children, ...props }) => {
  return (
    <Spin
      size={"large"}
      className={styles.spinner}
      indicator={<SpinningIcon />}
      {...props}
    >
      {children}
    </Spin>
  );
};
